import { useEffect, useState } from 'react'
import type { Swiper as SwiperType } from 'swiper'

export function useSwiperAtEnd(swiperRef: React.RefObject<SwiperType | null>): boolean {
	const [isEnd, setIsEnd] = useState(false)

	useEffect(() => {
		const inst = swiperRef.current
		if (!inst) return

		const handleProgress = (inst: SwiperType, progress: number) => {
			setIsEnd(progress === 1 || (progress === 0 && inst.isEnd))
		}

		const handleResize = (inst: SwiperType) => {
			setIsEnd(inst.isEnd)
		}

		inst.on('progress', handleProgress)
		inst.on('resize', handleResize)

		return () => {
			inst.off('progress', handleProgress)
			inst.off('resize', handleResize)
		}
	}, [swiperRef])

	return isEnd
}
